import { UGCPostType } from '@anytag/graphql';

export const defaultUGCPostsHashtags = {
  mentioned: { id: 'brand-mentions', postType: UGCPostType.MENTIONED },
  tagged: { id: 'tagged-posts', postType: UGCPostType.TAGGED }
};
